export enum OttosyncDataSourcesWorkspaceCapabilityAccessOperation {
    create = "1648ef6e-669c-4509-b6ac-c866f402d378",
    read = "6497726c-35fc-4cd5-8246-07effb492d89",
    update = "8a1f7c3c-9473-417b-99b0-c772f9829e76",
    delete = "a51905eb-6425-4c33-984e-40f12b18dd49",
}
